/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Select, message, Drawer, DatePicker, Form } from 'antd'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { 
	CRIME_TYPE, COMPLAIN_STATUS
} from '../../constants/lookup'

import ContituentSelect from '../../components/Custom/ConstituentSelect'
import Checkbox from '../../components/Custom/CustomCheckbox'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedComplainants: [{
				complainant_index: 1
			}],
			selectedRespondents: [{
				respondent_index: 1
			}],
			selectedRespondent: null,
			didSelectRespondent: false,
			selectedComplainant: null,
			didSelectComplainant: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	componentDidMount() {
		const { selectedComplain, form } = this.props
		const { setFieldsValue } = form
		if (selectedComplain) {
			const complainants = selectedComplain.complainants.map((i, key) => Object.assign({}, i, { complainant_index: (key+1) }))
			const respondents = selectedComplain.respondents.map((i, key) => Object.assign({}, i, { respondent_index: (key+1) }))
			this.setState({
				selectedComplainants: complainants,
				selectedRespondents: respondents
			}, () => {
				complainants.map(i => {
					setFieldsValue({
						[`is_complainant_resident_${i.complainant_index}`]: !_.isNull(i.complainant_ref_uid),
						[`complainant_name_${i.complainant_index}`]: i.complainant_name,
						[`complainant_address_${i.complainant_index}`]: i.complainant_address
					})
				})
				respondents.map(i => {
					setFieldsValue({
						[`is_respondent_resident_${i.respondent_index}`]: !_.isNull(i.respondent_ref_uid),
						[`respondent_name_${i.respondent_index}`]: i.respondent_name,
						[`respondent_address_${i.respondent_index}`]: i.respondent_address
					})
				})
			})
		}
	}
    
	handleSubmit(e) {
		e.preventDefault()
		let { selectedRespondents, selectedComplainants } = this.state
		const { history, form, AuthStore, saveComplain, onClose, isEdit, selectedComplain } = this.props
		const { barangay_uid, barangay_term_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			selectedComplainants = selectedComplainants.map(selectedComplainant => {
				const selectedConstituent = this.state[`selectedComplainant${selectedComplainant.complainant_index}`]
				const isResident = values[`is_complainant_resident_${selectedComplainant.complainant_index}`] || false
				const complainant_name = (selectedConstituent && isResident) ? `${selectedConstituent.first_name} ${selectedConstituent.middle_name || ''} ${selectedConstituent.last_name}` :
					values[`complainant_name_${selectedComplainant.complainant_index}`]
				const complainant_ref_uid = (selectedConstituent && isResident) ? selectedConstituent.uid : null
				const complainant_address = (selectedConstituent && isResident) ? `${selectedConstituent.house_no || ''} ${selectedConstituent.street || ''} ${selectedConstituent.address || ''} - ${selectedConstituent.purok_name}` : 
					values[`complainant_address_${selectedComplainant.complainant_index}`]
				return {
					...selectedComplainant,
					isComplainantResident: isResident,
					complainant_name,
					complainant_ref_uid,
					complainant_address
				}
			})

			selectedRespondents = selectedRespondents.map(selectedRespondent => {
				const selectedConstituent = this.state[`selectedRespondent${selectedRespondent.respondent_index}`]
				const isResident = values[`is_respondent_resident_${selectedRespondent.respondent_index}`] || false
				const respondent_name = (selectedConstituent && isResident) ? `${selectedConstituent.first_name} ${selectedConstituent.middle_name || ''} ${selectedConstituent.last_name}` :
					values[`respondent_name_${selectedRespondent.respondent_index}`]
				const respondent_ref_uid = (selectedConstituent && isResident) ? selectedConstituent.uid : null
				const respondent_address = (selectedConstituent && isResident) ? `${selectedConstituent.house_no || ''} ${selectedConstituent.street || ''} ${selectedConstituent.address || ''} - ${selectedConstituent.purok_name}` : 
					values[`respondent_address_${selectedRespondent.respondent_index}`]
				return {
					...selectedRespondent,
					isRespondentResident: isResident,
					respondent_name,
					respondent_ref_uid,
					respondent_address
				}
			})

			let params = Object.assign({}, values, {
				barangay_uid,
				barangay_term_uid,
				complainants: selectedComplainants,
				respondents: selectedRespondents
			})
			if (isEdit && selectedComplain) {
				params = Object.assign({}, params, { complain_uid: selectedComplain.uid })
			}
			// console.log('params', params)

			message.loading({ key: 'set_brgy_complain', content: 'Saving Complain, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveComplain(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_brgy_complain', content: 'Complain successfully saved.' })

					if (isEdit && selectedComplain) {
						//create audit trail
						const auditParams = {
							module_name: 'Complains',
							action: 'Update',
							message: `Update complain with case no ${params.case_no}`
						}
						AuthStore.saveAuditTrail(auditParams)
					} else {
						//create audit trail
						const auditParams = {
							module_name: 'Complains',
							action: 'Create',
							message: 'Created new complain'
						}
						AuthStore.saveAuditTrail(auditParams)
					}

					const { uid } = response.data.setComplain
					history.push({ pathname: `/complains/details/${uid}` })
					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving barangay complain')
					message.error({ key: 'set_brgy_complain', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, selectedComplain, AuthStore } = this.props
		const { getFieldDecorator, getFieldValue } = form
		const { barangay_uid } = AuthStore
		const { 
			isSaving, selectedComplainants, selectedRespondents
		} = this.state
        
		return (
			<Drawer
				title="Complaint Management"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'75%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row gutter={16}>
						<Col md={12} sm={24}>
							<legend>Complainant</legend>
							{
								selectedComplainants.map((i, key) => (
									<Row key={key} style={{ marginTop: 10, padding: 10, border: '1px solid #ccc', borderRadius: 16 }}>
										<Row style={{ marginBottom: -35 }}>
											<Form.Item label=''>
												{ getFieldDecorator(`is_complainant_resident_${i.complainant_index}`, {
													//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
													rules: [{
														required: false,
														message: 'This field is required.'
													}, {
														validator: (rule, value, callback) => {
															if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																callback('only white space detected.')
															}
															callback()
														}
													}]
												})
												(
													<Checkbox 
														style={{ color: 'red' }}
													>Is complainant {i.complainant_index} Resident?
													</Checkbox>
												)}
											</Form.Item>
										</Row>
										{
											(getFieldValue(`is_complainant_resident_${i.complainant_index}`) || 
											(selectedComplain && getFieldValue(`is_complainant_resident_${i.complainant_index}`) && !_.isNull(selectedComplain.complainant_ref_uid))) &&
											<Row>
												<Form.Item label={`Complainant ${i.complainant_index}`}>
													{ getFieldDecorator(`complainant_name_${i.complainant_index}`, {
														//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
														rules: [{
															required: true,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<ContituentSelect
															barangay_uid={barangay_uid}
															placeholder='Select Complainant name'
															onSelectedItem={(item) => {
																this.setState({ [`selectedComplainant${i.complainant_index}`]: Object.assign({}, item, { didSelectComplainant: true }) })
															}}
														/>
													)}
												</Form.Item>
											</Row>
										}
										{
											(!getFieldValue(`is_complainant_resident_${i.complainant_index}`) || 
											(selectedComplain && !getFieldValue(`is_complainant_resident_${i.complainant_index}`) && _.isNull(selectedComplain.complainant_ref_uid))) &&
											<Row>
												<Form.Item label={`Complainant ${i.complainant_index}`}>
													{ getFieldDecorator(`complainant_name_${i.complainant_index}`, {
														initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
														rules: [{
															required: true,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<Input placeholder='Enter Complainant name' />
													)}
												</Form.Item>
											</Row>
										}
										{
											(!getFieldValue(`is_complainant_resident_${i.complainant_index}`) || 
											(selectedComplain && !getFieldValue(`is_complainant_resident_${i.complainant_index}`) && _.isNull(selectedComplain.complainant_ref_uid))) &&
											<Row>
												<Form.Item label={`Complainant Address ${i.complainant_index}`}>
													{ getFieldDecorator(`complainant_address_${i.complainant_index}`, {
														initialValue: (selectedComplain) ? selectedComplain.complainant_address : null,
														rules: [{
															required: true,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<Input placeholder='Enter Complainant address' />
													)}
												</Form.Item>
											</Row>
										}
										{
											((key > 0) && ((key + 1) == (selectedComplainants.length))) &&
											<Row type='flex' justify='center'>
												<a 
													style={{ color: 'red' }}
													onClick={() => {
														selectedComplainants.splice(key)
														this.setState({ selectedComplainants })
													}}
												>Delete</a>
											</Row>
										}
									</Row>
								))
							}
							<Row type='flex' justify='center'>
								<a 
									style={{ color: 'blue' }}
									onClick={() => {
										const newComplainant = { complainant_index: (selectedComplainants.length + 1) }
										selectedComplainants.push(newComplainant)
										this.setState({ selectedComplainants })
									}}
								>+ Add Complainant</a>
							</Row>
						</Col>
						<Col md={12} sm={24}>
							<legend>Respondent</legend>
							{
								selectedRespondents.map((i, key) => (
									<Row key={key} style={{ marginTop: 10, padding: 10, border: '1px solid #ccc', borderRadius: 16 }}>
										<Row style={{ marginBottom: -35 }}>
											<Form.Item label=''>
												{ getFieldDecorator(`is_respondent_resident_${i.respondent_index}`, {
													//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
													rules: [{
														required: false,
														message: 'This field is required.'
													}, {
														validator: (rule, value, callback) => {
															if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																callback('only white space detected.')
															}
															callback()
														}
													}]
												})
												(
													<Checkbox 
														style={{ color: 'red' }}
													>Is respondent {i.respondent_index} Resident?
													</Checkbox>
												)}
											</Form.Item>
										</Row>
										{
											(getFieldValue(`is_respondent_resident_${i.respondent_index}`) || 
											(selectedComplain && getFieldValue(`is_respondent_resident_${i.respondent_index}`) && !_.isNull(selectedComplain.respondent_ref_uid))) &&
											<Row>
												<Form.Item label={`Respondent ${i.respondent_index}`}>
													{ getFieldDecorator(`respondent_name_${i.respondent_index}`, {
														//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
														rules: [{
															required: true,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<ContituentSelect
															barangay_uid={barangay_uid}
															placeholder='Select Respondent name'
															onSelectedItem={(item) => {
																this.setState({ [`selectedRespondent${i.respondent_index}`]: Object.assign({}, item, { didSelectRespondent: true }) })
															}}
														/>
													)}
												</Form.Item>
											</Row>
										}
										{
											(!getFieldValue(`is_respondent_resident_${i.respondent_index}`) || 
											(selectedComplain && !getFieldValue(`is_respondent_resident_${i.respondent_index}`) && _.isNull(selectedComplain.respondent_ref_uid))) &&
											<Row>
												<Form.Item label={`Respondent ${i.respondent_index}`}>
													{ getFieldDecorator(`respondent_name_${i.respondent_index}`, {
														initialValue: (selectedComplain) ? selectedComplain.respondent_name : null,
														rules: [{
															required: true,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<Input placeholder='Enter Respondent name' />
													)}
												</Form.Item>
											</Row>
										}
										{
											(!getFieldValue(`is_respondent_resident_${i.respondent_index}`) || 
											(selectedComplain && !getFieldValue(`is_respondent_resident_${i.respondent_index}`) && _.isNull(selectedComplain.respondent_ref_uid))) &&
											<Row>
												<Form.Item label={`Respondent Address ${i.respondent_index}`}>
													{ getFieldDecorator(`respondent_address_${i.respondent_index}`, {
														initialValue: (selectedComplain) ? selectedComplain.respondent_address : null,
														rules: [{
															required: true,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<Input placeholder='Enter Respondent address' />
													)}
												</Form.Item>
											</Row>
										}
										{
											((key > 0) && ((key + 1) == (selectedRespondents.length))) &&
											<Row type='flex' justify='center'>
												<a 
													style={{ color: 'red' }}
													onClick={() => {
														selectedRespondents.splice(key)
														this.setState({ selectedRespondents })
													}}
												>Delete</a>
											</Row>
										}
									</Row>
								))
							}
							<Row type='flex' justify='center'>
								<a 
									style={{ color: 'blue' }}
									onClick={() => {
										const newRespondent = { respondent_index: (selectedRespondents.length + 1) }
										selectedRespondents.push(newRespondent)
										this.setState({ selectedRespondents })
									}}
								>+ Add Respondent</a>
							</Row>
						</Col>
					</Row>
					<legend>Details</legend>
					<Row gutter={16}>
						<Col md={12} sm={24}>
							<Form.Item label='Nature of Case'>
								{ getFieldDecorator('nature_of_case', {
									initialValue: (selectedComplain) ? selectedComplain.nature_of_case : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Nature of Case'>
										{
											CRIME_TYPE.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							{
								(getFieldValue('nature_of_case') && _.isEqual(getFieldValue('nature_of_case'), 'Other crimes (specify)')) &&
							<Row>
								<Form.Item label='Specific Case'>
									{ getFieldDecorator('specific_case', {
										initialValue: (selectedComplain) ? selectedComplain.specific_case : null,
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Enter specific case' />
									)}
								</Form.Item>
							</Row>
							}
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Date filed'>
								{ getFieldDecorator('date_filed', {
									initialValue: (selectedComplain) ? moment(selectedComplain.date_filed) : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<DatePicker format='LLL' showTime style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Details'>
								{ getFieldDecorator('complain_details', {
									initialValue: (selectedComplain) ? selectedComplain.complain_details : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter complain details' />
								)}
							</Form.Item>
						</Col>
						{
							!selectedComplain &&
							<Col md={12} sm={24}>
								<Form.Item label='Remarks'>
									{ getFieldDecorator('remarks', {
										initialValue: (selectedComplain) ? selectedComplain.remarks : null,
										rules: [{
											required: false,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input.TextArea placeholder='Enter complain remarks' />
									)}
								</Form.Item>
							</Col>
						}
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button disabled={isSaving} type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_BARANGAY_COMPLAIN = gql`
    mutation setComplain($input: JSON) {
		setComplain(input: $input)
    }
`

const composed = compose(
	withRouter,
	Form.create({ name: 'form-barangay-complain' }),
	inject('AuthStore'),
	graphql(SET_BARANGAY_COMPLAIN, {
		props({ mutate }) {
			return {
				saveComplain(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayComplains','barangayBlotters']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
